import * as Bytescale from '@bytescale/sdk';

(async () => {
  if (!customElements.get('contact-form')) {
    class ContactForm extends HTMLElement {
      constructor() {
        super();

        // options
        this.options = {
          apiKey: parseJson(this.dataset.options).apiKey,
          accountId: parseJson(this.dataset.options).accountId,
          maxFileSize:
            parseInt(parseJson(this.dataset.options).maxFileSize) * Math.pow(1024, 2) ||
            10 * Math.pow(1024, 2),
          path:
            `/${parseJson(this.dataset.options).path}/{UTC_YEAR}/{UTC_MONTH}/{UTC_DAY}` ||
            '/contactForm/{UTC_YEAR}/{UTC_MONTH}/{UTC_DAY}',
        };

        if (!this.options.apiKey && !this.options.accountId) {
          console.warn('Upload API key is required');
          return;
        }

        // upload manager
        this.uploadManager = new Bytescale.UploadManager({
          apiKey: this.options.apiKey,
        });

        this.init();
      }

      init() {
        this.blockSubmit = false;

        // elements
        this.form = this.querySelector('form');
        this.submit = this.querySelector('button[type=submit]');
        this.fileUrl = this.querySelector('#contact-form__file-urls');

        this.fileInputWrapper = this.querySelector('[data-file-input-wrapper]');
        this.input = this.querySelector('input[type="file"]');
        this.label = this.fileInputWrapper.querySelector('label');
        this.trigger = this.querySelector('[data-file-trigger]');

        // errors and messages
        this.uploadMessage = this.querySelector('[data-message-upload]');
        this.uploadSuccess = this.querySelector('[data-message-success]');
        this.uploadError = this.querySelector('[data-error-upload]');
        this.fileSizeError = this.querySelector('[data-error-file-size]');

        // event listeners
        this.trigger.addEventListener('click', this.handleTriggerClick.bind(this));
        this.input.addEventListener('change', this.handleFileSelect.bind(this));
        this.submit.addEventListener('click', this.submitHandler.bind(this));
      }

      /**
       * Reset the input file
       */
      resetInput() {
        this.input.value = [];
        this.fileInputWrapper.classList.remove('file-selected');
      }

      // handle trigger click
      handleTriggerClick() {
        if (this.input.files.length > 0) {
          this.resetInput();
          this.fileSizeError.classList.add('hidden');
        } else {
          this.label.click();
        }
      }

      /**
       * On change, if there is a file selected, show the file name instead of placeholder
       */
      handleFileSelect() {
        this.fileSizeError.classList.add('hidden');
        if (this.input.files.length > 0) {
          this.fileInputWrapper.classList.add('file-selected');
          this.querySelector('[data-file-name]').textContent = this.input.files[0].name;

          if (this.input.files[0].size > this.options.maxFileSize) {
            this.fileSizeError.classList.remove('hidden');

            this.blockSubmit = true;
          } else {
            this.blockSubmit = false;
          }
        }
      }

      async submitHandler(event) {
        event.preventDefault();

        if (this.input.files.length > 0) {
          if (!this.blockSubmit) {
            try {
              this.uploadMessage.classList.remove('hidden');
              this.submit.classList.add('loading');

              await this.uploadManager
                .upload({
                  // requited params
                  accountId: this.options.accountId,
                  data: this.input.files[0],

                  // optional params
                  // save name and phone as tags
                  tags: [
                    `name-${this.querySelector('#contact-form__name').value.replace(/ /g, '-')}`,
                    `phone-${this.querySelector('#contact-form__phone').value.replace(/ /g, '-')}`,
                  ],
                  // set the path and file name
                  path: {
                    folderPath: this.options.path,
                    fileName: '{UTC_TIME_TOKEN_INVERSE}{UNIQUE_DIGITS_2}{ORIGINAL_FILE_EXT}',
                  },
                })
                .then((response) => {
                  // reset input file
                  this.resetInput();

                  // add the file url to the hidden input
                  this.fileUrl.value = response.fileUrl;

                  // hide the upload message
                  this.uploadMessage.classList.add('hidden');

                  // show the success message
                  this.uploadSuccess.classList.remove('hidden');

                  setTimeout(() => {
                    this.uploadSuccess.classList.add('hidden');
                  }, 1000);

                  // remove loading class
                  this.submit.classList.remove('loading');

                  // submit the form
                  if (this.form.reportValidity()) this.form.submit();
                });
            } catch (error) {
              console.log(error);
              this.submit.classList.remove('loading');
              this.uploadError.classList.remove('hidden');
            }
          }
        } else {
          if (this.form.reportValidity()) this.form.submit();
        }
      }
    }
    customElements.define('contact-form', ContactForm);
  }
})();
